// extracted by mini-css-extract-plugin
export default {"wrapper":"TextValue_wrapper__1BY7Q","label":"TextValue_label__aTf9d","value":"TextValue_value__JuvEu"};